import { Avatar, Badge, Button, Menu } from "../design";
import useTranslator from "../../hooks/useTranslator";
import "./guarantorCards.css";

/** Card layout shared by the guarantor / income source cards. */
export const GuarantorCard = ({
  name,
  relation,
  email,
  amount,
  status,
  menu,
  bare = false,
  onClick,
}) => (
  <div
    className={`guarantor-card ${bare ? "guarantor-card--bare" : ""}`.trim()}
    onClick={onClick}
  >
    <Avatar name={name} size="md" className="guarantor-card__avatar" />
    <span className="guarantor-card__name">{name}</span>
    {menu ? <div className="guarantor-card__menu-wrap">{menu}</div> : null}
    {relation || status ? (
      <div className="guarantor-card__badges">
        {relation ? <Badge tone="neutral">{relation}</Badge> : null}
        {status}
      </div>
    ) : null}
    {email ? <span className="guarantor-card__email">{email}</span> : null}
    {amount ? <span className="guarantor-card__amount">{amount}</span> : null}
  </div>
);

const statusTone = (status = "") => {
  if (status === "completed") return "lime";
  if (/declin|fail|reject|error/i.test(status)) return "danger";
  if (/pending|processing|analysis|accept|wait/i.test(status)) return "warning";
  return "neutral";
};

/** Badge for the result of getGuarantorStatus(). */
export const GuarantorStatusBadge = ({ statusData }) => {
  const { _t } = useTranslator();
  const label =
    statusData?.status === "completed"
      ? _t("profileComplete", "Profile complete")
      : _t(statusData?.status);
  return (
    <Badge tone={statusTone(statusData?.status)}>
      {statusData?.pendingFrom
        ? `${label} · ${_t(statusData.pendingFrom)}`
        : label}
    </Badge>
  );
};

/** Three-dot button and, when open, its dropdown. Items are shared Menu items. */
export const GuarantorMenu = ({ items, open, onToggle, label }) => (
  <>
    <Button
      variant="ghost"
      size="sm"
      iconOnly
      aria-label={label}
      aria-haspopup="menu"
      aria-expanded={Boolean(open)}
      iconStart={
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          aria-hidden="true"
        >
          <circle cx="8" cy="3" r="1.5" />
          <circle cx="8" cy="8" r="1.5" />
          <circle cx="8" cy="13" r="1.5" />
        </svg>
      }
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    />
    {open && <Menu items={items} className="guarantor-card__menu" />}
  </>
);
